<div class="row" *ngIf="!loader">
    <div class="col-12">
        <mat-card appearance="outlined">
            <sm-title-bar pageSubTitle="All blocked/un-blocked accounts" [showBackButton]="true"></sm-title-bar>
            <div class="rounded-3 bg-light">
              <sm-data-table [columnHeaders]="tableDisplayColumns" [dataSource]="accountList"
                [showMenuButton]="true" [menuDropdownTemplate]="menuTemplate" [showPagination]="true" [itemsPerPage]="10" [showFilter]="true">
              </sm-data-table>
            </div>
          </mat-card>
    </div>
</div>
<div *ngIf="loader" class="loader">
  <mat-spinner></mat-spinner>
</div>
<ng-template #menuTemplate let-value>
    <!-- <button mat-menu-item (click)="viewProfile(value)">
      <mat-icon class="material-icons-outlined">account_circle</mat-icon>
      <span>See profile</span>
    </button> -->
    <button mat-menu-item>
      <mat-icon class="material-icons-outlined">email</mat-icon>
      <span>Send message</span>
    </button>
    <button mat-menu-item *ngIf="value.block_unblock_status == 'Blocked'" (click)="unblock(value)">
      <mat-icon class="material-icons-outlined">email</mat-icon>
      <span>Un-block</span>
    </button>
  </ng-template>